module.exports = __webpack_public_path__ + "88be67d8a180505e728665db74b258.png";